import { FormErrorCode } from "../entities/FormErrorCode";

export function mapErrorCodeToErrorText(errorCode: string): string {
    if (errorCode === "noDoctorInsuranceGroup1") {
        return "Borger har ingen læge";
    }
    if (errorCode === "insuranceGroup2") {
        return "Borgeren er i sygesikringsgruppe 2";
    }
    switch (Number(errorCode)) {
        case FormErrorCode.UnknownError:
            return "Ukendt fejl";
        case FormErrorCode.CprLookupError:
            return "Fejl i CPR-opslag";
        case FormErrorCode.ClinicLookupError:
            return "Fejl i opslag af tilknyttet læge";
        case FormErrorCode.InvalidDataFromVirk:
        case FormErrorCode.UnknownXmlFormat:
        case FormErrorCode.MissingMunicipalityCodeInXml:
        case FormErrorCode.MissingCitizeninfoFromXml:
        case FormErrorCode.NameNotFound:
        case FormErrorCode.LastNameNotFound:
        case FormErrorCode.NameInvalid:
        case FormErrorCode.ResourceNotFound:
        case FormErrorCode.CaseNotFetched:
        case FormErrorCode.GpSystemCredentials:
        case FormErrorCode.ReceivingFromGpSystem:
        case FormErrorCode.InvalidDataFromGpSystem:
        case FormErrorCode.ThirdPartyError:
        case FormErrorCode.NoSenderToDoctor:
            return "Ukendt fejl";
        case FormErrorCode.DigitalPostSender:
            return "Fejl i DigitalPost afsender";
        case FormErrorCode.DigitalPostReceiver:
            return "Fejl i DigitalPost modtager";
        default:
            return `Øvrige fejl (${errorCode})`;
    }
}
